import React, { useEffect, useState } from 'react';
import { Alert, Button, Col, FormGroup, Row, Spinner } from 'reactstrap';
import { getActiveConsentDocument } from 'api/member';

export const getConsentDocument = (response) => response?.data || response;

export const getDocumentByType = (documents, type) => {
  if (!documents) return null;
  if (documents[type]) return documents[type];
  if (Array.isArray(documents)) {
    return documents.find((document) => document?.type === type) || null;
  }
  return documents?.type === type ? documents : null;
};

export const getConsentText = (documents) => {
  const document = getDocumentByType(documents, 'CONSENT') || documents;
  return (
  document?.consentText ||
  document?.consentContent ||
  document?.consentStatement ||
  document?.consent ||
  document?.privacyNotice ||
  document?.content?.consent ||
  (typeof document?.content === 'string' ? document.content : '') ||
  ''
  );
};

export const getDeclarationText = (documents) => {
  const document = getDocumentByType(documents, 'DECLARATION') || documents;
  return (
  document?.declarationText ||
  document?.declarationContent ||
  document?.declarationStatement ||
  document?.declaration ||
  document?.content?.declaration ||
  (typeof document?.content === 'string' ? document.content : '') ||
  ''
  );
};

const ConsentGate = ({ onAccept }) => {
  const [accepted, setAccepted] = useState(true);
  const [document, setDocument] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    getActiveConsentDocument()
      .then(setDocument)
      .catch((err) => setError(err?.message || 'The active consent document could not be loaded.'))
      .finally(() => setLoading(false));
  }, []);

  const activeDocuments = getConsentDocument(document);
  const consentDocument = getDocumentByType(activeDocuments, 'CONSENT');
  const declarationDocument = getDocumentByType(activeDocuments, 'DECLARATION');
  const documentId = consentDocument?.id || consentDocument?.documentId || consentDocument?.consentDocumentId;
  const consentText = getConsentText(activeDocuments);

  return (
    <Row className="justify-content-center py-4">
      <Col lg="8">
        <h4 className="mb-3">Member consent</h4>
        <p className="text-muted">
          The prospective member must review and accept this consent before registration begins.
        </p>
        <Alert color="light" className="border lh-lg">
          {consentText || 'The active consent document does not contain consent text.'}
        </Alert>
        {loading ? (
          <div className="text-muted mb-3"><Spinner size="sm" className="me-2" />Loading consent document...</div>
        ) : null}
        {error ? <Alert color="danger">{error}</Alert> : null}
        <FormGroup className="form-check mb-4">
          <label className="form-check-label d-flex align-items-start gap-2" htmlFor="memberConsent">
            <input
              id="memberConsent"
              className="form-check-input flex-shrink-0 mt-1"
              type="checkbox"
              checked={accepted}
              disabled={loading || !!error || !documentId || !consentText}
              onChange={(event) => setAccepted(event.currentTarget.checked)}
            />
            The member has read, understood, and voluntarily gives this consent.
          </label>
        </FormGroup>
        <Button
          color="primary"
          disabled={!accepted || !documentId || !consentText}
          onClick={() => onAccept({
            consentDocumentId: documentId,
            declarationDocumentId:
              declarationDocument?.id ||
              declarationDocument?.documentId ||
              declarationDocument?.consentDocumentId,
            document: activeDocuments,
          })}
        >
          Accept and start registration
        </Button>
      </Col>
    </Row>
  );
};

export default ConsentGate;
